import NotImplemented from '../../../../common/pages/NotImplemented'

const Actions = () => {
    return (
        <NotImplemented
            header={{ header: 'Google Analytics Event Actions' }}
            label={
                <>
                    <span className="text-primary">Analytics Actions</span> has
                    not been implemented yet!
                </>
            }
            description={
                <p>
                    I'm currently reviewing{' '}
                    <span className="text-success">Analytics</span> as Google
                    have changed it recently and will try to make it a little
                    bit broader!
                </p>
            }
        />
    )
}

export default Actions
